import BaseEvent from './BaseEvent.js';
import { getOSM } from '../../OverworldAnimation.js';
import { RIGHT, UP, LEFT, DOWN } from '../../constants.js';
export default class ThankYouForLunchbox extends BaseEvent {
    constructor({
        identifier = 'thank_you_for_lunchbox',
        isActive = true,
        complete = false,
        autoComplete = true,
        objectsIdentifiers = ['lab_professor', 'lab_rival'],
    } = {}) {
        super({ identifier, isActive, complete, autoComplete, objectsIdentifiers });
    }

    static deserialize(data) {
        return new ThankYouForLunchbox({
            isActive: data.isActive,
            complete: data.complete,
        });
    }

    executeActions() {
        const osm = getOSM();
        const player = osm.player;
        const professor = this.getObject('lab_professor');
        const rival = this.getObject('lab_rival');
        professor.name = 'Professor Abu';
        rival.name = 'Rumbi';
        if (!osm.shouldSkipOverworldEvents()) {
            osm.readText(() => `${player.name}! Any luck finding my Lunch Box?`, {
                speaker: () => professor.name,
            });
            osm.continueReading();
            osm.readText(() => `Get over here!`);
            osm.finishReading();
        }
        osm.movePlayer([{ up: 7 }]);
        if (!osm.shouldSkipOverworldEvents()) {
            osm.readText(() => `That’s it! Thank you so much!`, { speaker: () => professor.name });
            osm.continueReading();
            osm.readText(() => `Looks like everything is still in here.`);
            osm.continueReading();
            osm.readText(() => `It’s now my turn to hold up my end of the bargain!`);
            osm.continueReading();
            osm.readText(() => `I was going to give you a Rare Candy as a reward, but...`);
            osm.continueReading();
            osm.readText(() => `I think I have a better idea.`);
            osm.continueReading();
            osm.readText(() => `On my table there, there are 3 Pokémon.`);
            osm.continueReading();
            osm.readText(() => `Take your pick.`);
            osm.continueReading();
            osm.readText(() => `... ... ... ... ... ...`);
            osm.continueReading();
            osm.readText(
                () =>
                    `No, Seriously! Any of these will make a wonderful addition to your party.`
            );
            osm.continueReading();
            osm.readText(() => `This may seem a bit excessive...`);
            osm.continueReading();
            osm.readText(() => `But I promise you, there are no strings attached.`);
            osm.continueReading();
            osm.readText(
                () =>
                    `As a Pokemon Professor, it's my duty to help young aspiring trainers.`
            );
            osm.continueReading();
            osm.readText(() => `Especially those with as much potential as you both!`);
            osm.continueReading();
            osm.readText(() => `I have no doubt it will be worth it for all of us!`);
            osm.continueReading();
            osm.readText(() => `So go right ahead!`);
            osm.finishReading();
        }

        osm.moveNPC(rival, UP, 1);
        osm.moveNPC(rival, RIGHT, 4);

        osm.script(() => {
            professor.direction = RIGHT;
            rival.direction = LEFT;
            professor.showExclamationMark();
        });
        osm.delay(30);
        osm.readText(
            () => `Hold on ${rival.name}! You’ll make your pick after ${player.name}!`, {
                speaker: () => professor.name,
            }
        );
        osm.continueReading();
        osm.readText(() => `Okay...`, { speaker: () => rival.name });
        osm.finishReading();
        osm.script(() => {
            rival.direction = DOWN;
        });
        osm.script(() => {
            osm.currentMap.getEventTriggersByIdentifier('dont_forget_your_starter').forEach((et) => {
                et.getEvent().isActive = true;
            });
        });
        osm.movePlayer([{ up: 1 }]);
    }
}
